/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const View16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill="#444"
            d="M0 7.866l.07-.188C1.342 4.284 4.466 2 8.001 2c3.536 0 6.66 2.284 7.929 5.679l.07.187-.07.188c-1.27 3.395-4.394 5.68-7.929 5.68-3.536 0-6.66-2.285-7.93-5.68L0 7.866zm8.001 4.801c3.018 0 5.702-1.917 6.862-4.8-1.16-2.884-3.844-4.8-6.862-4.8-3.018 0-5.702 1.916-6.864 4.8 1.162 2.883 3.846 4.8 6.864 4.8zm0-7.467a2.657 2.657 0 012.654 2.666A2.658 2.658 0 018 10.533a2.657 2.657 0 01-2.656-2.665A2.66 2.66 0 018.001 5.2zm0 1.067c-.882 0-1.594.714-1.594 1.6a1.593 1.593 0 103.186-.001c0-.885-.711-1.6-1.592-1.6v.001z"
        />
    </AccessibleSVG>
);

export default View16;
